<template>
  <v-flex
    class="primary"
    column
    role="region"
    aria-label="FAQ content"
  >
    <!-- Decorative banner image for FAQ page -->
    <v-parallax
      src="https://gm.goz.fun/wp-content/uploads/2023/03/faq-cover.png"
      height="400"
      role="img"
      aria-label="Frequently Asked Questions banner"
    />

    <!-- Main FAQ container -->
    <v-container
      role="main"
      aria-label="Frequently Asked Questions section"
    >
      <v-card>
        <!-- Page title -->
        <v-app-bar
          flat
          color="primary"
          class="font-weight-thin text-uppercase"
          role="heading"
          aria-level="1"
        >
          {{ $t('components.faq.title') }}
        </v-app-bar>
        <v-card-text>{{ $t('components.faq.description') }}</v-card-text>
      </v-card>

      <!-- FAQ list -->
      <v-layout wrap>
        <v-flex
          v-for="faq in faqList"
          :key="faq.id"
          full-width
          lg12
          role="listitem"
        >
          <v-card
            v-if="faq.isActive"
            color="secondary"
            full-width
          >
            <!-- Clickable / focusable question title -->
            <v-card-title
              class="grey--text text-subtitle-2 primary"
              role="button"
              :tabindex="0"
              :aria-expanded="isCardVisible(faq.id)"
              @click="ViewFAQ(faq.id)"
              @keydown.enter="ViewFAQ(faq.id)"
              @keydown.space.prevent="ViewFAQ(faq.id)"
            >
              {{ faq.title }}
            </v-card-title>

            <!-- Collapsible answer region -->
            <v-slide-y-transition>
              <v-card-text
                v-show="isCardVisible(faq.id)"
                class="faq-collapsable-text"
                role="region"
                :aria-hidden="!isCardVisible(faq.id)"
              >
                {{ faq.description }}
              </v-card-text>
            </v-slide-y-transition>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
import faqList from "@/constants/faq.list";

export default {
  name: "FAQ",
  data() {
    return {
        cardsOptions: [],
        isLoading: false,
    }
  },
  computed: {
    faqList() {
        return faqList.list.map((item) => ({
            ...item,
            title: this.$t(item.title),
            description: this.$t(item.description)
        }))
    },
  },
  beforeMount() {
    this.isLoading = true;
    // Setup our state
    this.faqList.map(({ id }) => {
      this.cardsOptions[id] = {
        visibile: false
      };
    });
  },
  mounted() {
    this.isLoading = false;
  },
  methods: {
    /**
     * Will handle the toggle of showing the text for the current card
     */
    ViewFAQ(id) {
        if (!this.cardsOptions[id]) {
            return false;
        }

        // Toggle visibility - if currently visible, hide it; if hidden, show it
        this.cardsOptions = this.cardsOptions.map((val, faqId) => ({
            ...val,
            visibile: faqId === id ? !this.cardsOptions[id].visibile : false,
        }));

        return true;
    },
    /**
     * Check if card visible or not
     */
    isCardVisible(id) {
      return this.cardsOptions[id].visibile;
    }
  }
};
</script>

<style lang="scss">
    @import '~/_variables.scss';

    .faq {
        &-collapsable-text {
            white-space: pre-line;
            padding: 1.5rem;
            padding-top: 0;
        }
    }
</style>
